import { createFileRoute } from '@tanstack/react-router';
import { GmProfilePage } from '@/features/admin/gm-profile-page';

export const Route = createFileRoute('/gm/profile')({
  component: () => <GmProfilePage />,
});
